import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { blurActiveElement } from 'utils/dom';

export const useResetUIOnRouteChange = () => {
  const location = useLocation();

  useEffect(() => {
    blurActiveElement();
  }, [location]);
};
